<template>
    <div>
        <div class="w" id="content">
            <div class="s_tl">
                当前位置：<a href="/">首页</a>
                <em class="lr3">&#62;</em>
                <a href="/help">帮助中心</a>
                <em class="lr3">&#62;</em>
                <a href="">新手上路</a>
                <em class="lr3">&#62;</em>
                <a href="">货到付款</a>
            </div>
            <div class="ubg">
                <left-side></left-side>
                <!--left over-->
                <div class="u_r">
                    <div class="ah1 alC yahei">
                        <h1 class="f18">货到付款</h1>
                        <p class="c9">发布时间：2022-01-04</p>
                    </div>
                    <div class="ainfo ov yahei">
                        <p><strong >一、什么是货到付款</strong></p>
                        <p >货到付款指客户签收商品后，再将货款给快递员的一种结算方式；保障了客户的财产安全，也体现了夜樱情趣商城以客户为中心的服务理念；</p>
                        <p><br></p>
                        <p><strong >二、货到付款注意事项</strong></p>
                        <p>1、夜樱情趣商城委托顺丰快递、中通及邮政EMS等合作快递为您提供货到付款服务。收到商品后，将货款交于快递人员即可，如有其他人员告知将货款转于某某账号，请注意诈骗</p>
                        <p>2、货到付款验货方式： 夜樱情趣商城是委托第三方快递公司来为您配送商品，商品送达时，您可以要求先验货，后付款(由于快递公司仅对快递本身的及时性安全性负责。因此如快递员不允许您在签收前开箱检查商品，还望理解。您也可以直接致电夜樱情趣商城客服中心(400-660-0606)，由客服代表协助您与快递人员交涉验货事宜)。</p>
                        <p><br></p>
                        <p >※温馨提示※</p>
                        <p>1、订单金额满198元，货到付款可包邮；如未满198元，货到付款需加15元运费；</p>
                        <p>2、订单金额满99元，夜樱情趣商城会优先安排发顺丰快递，若顺丰快递不能到达，会选择其他快递送达；</p>
                    </div>
                    <!--info over-->
                    <p><br></p>
                    <p class="lh30"></p>
                    <p class="bline" style="padding: 30px 0px 0 0;"></p>
                    <p class="lh30"></p>
                    <p style="font-size:16px;">
                        <a href="/help/appdinggou" style="float:left;">上一篇:APP订购</a>
                        <a href="/help/yinhang" class="pl10" style="float:right">下一篇:银行汇款</a>
                    </p>
                </div>
                <!--right over-->
                <div class="clear"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Left_side from "@/components/help/left-side"
export default {
    components:{
        'left-side': Left_side
    },
}
</script>

<style scoped>
.ainfo {line-height: 32px;padding-top: 10px;font-size: 14px;}
.ubg{border:1px solid #e5e5e5;background-color:#fff;overflow:hidden;}
.u_l{width:170px;padding:10px;background:#fff;border-right:1px solid #e5e5e5;}
.u_r{padding:10px 40px 30px 40px;border-left:1px solid #e5e5e5;line-height:25px;background:#fff;margin-left:190px;min-height:600px;}
.dsl{display:inline;font-weight:normal;}
.udl{margin:0 5px 15px 5px;}
.udl dt{border-bottom:1px solid #e5e5e5;line-height:40px;display:block;font-size:14px;color:#333;font-weight:bold;margin-bottom:10px;}
.udl dd{line-height:30px;text-indent:15px;}
.udl a{display:block;color:#777;margin-bottom:1px;}
.udl a:hover,.udl a.on{color:#c40000;text-decoration:none; background-color:#e5e1e1;}
.article{width:100%;}
.article li{border-bottom:1px dashed #ddd;display:block;width:100%;font-size:14px;line-height:45px;}
.article a{display:block;width:100%;overflow:hidden;}
.article a:hover{color:#c40000;}
.ah1{color:#333;line-height:30px;padding-bottom:10px;border-bottom:2px solid #ddd;}
.a_goods a{width:220px;height:280px;display:inline;float:left;margin:10px 6px;line-height:18px;white-space:nowrap;overflow:hidden;}
</style>


// WEBPACK FOOTER //
// src/components/help/huodaofukuan.vue